import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, ClickAwayListener } from '@mui/material';
import '../Card/CardBody.js';
import '../Card/CardItem.js';
import { Wrapper as WrapperTyped } from '../Card/CardWrapper.js';
import '../Card/components/Description.js';
import '../Card/Form.js';

function FiltersWrapper(_a) {
    var { isActive, onClickAway } = _a, restProps = __rest(_a, ["isActive", "onClickAway"]);
    if (!isActive) {
        return null;
    }
    return (jsx(ClickAwayListener, { onClickAway: onClickAway, children: jsx(Container, Object.assign({}, restProps)) }));
}
const Container = styled(WrapperTyped)(({ theme }) => ({
    position: "absolute",
    left: 0,
    top: `calc(100% + ${theme.spacing(0.5)})`,
    display: "flex",
    flexDirection: "column",
}));

export { FiltersWrapper };
//# sourceMappingURL=FiltersWrapper.js.map
